module.exports = __webpack_public_path__ + "static/bluesafari2-c89bd4bf4a49d33c310a3c6f83d9b09d.jpeg";